import React from 'react'
import { StickBackground, StickContainer, StickContent } from './styles'
import { DolaThemes } from '../../styles/types'

interface StickProps {
  active?: boolean
  theme: DolaThemes
}

const Stick: React.FC<StickProps> = ({ active, theme }) => {
  return (
    <StickContainer>
      <StickBackground dolaTheme={theme}>
        <StickContent
          mode={active ? 'active' : 'default'}
          dolaTheme={theme}
        />
      </StickBackground>
    </StickContainer>
  )
}

export default Stick
